module.exports = __webpack_public_path__ + "static/img/index.93b1f1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/mapPicture/yunnan/index.png
// module id = zMTJ
// module chunks = 6